import React from 'react';
import { FullBackground } from '../../../components/FullBackground';
import { useHistory } from 'react-router';

type Props = {
  className?: string;
};

const ProductFeatures: React.FC<Props> = ({ className }) => {
  const history = useHistory();
  return (
    <>
      <FullBackground color={'bg-white'} isSlanted={false}>
        <div
          className="relative py-16 lg:py-24 bg-white"
          style={{ marginLeft: '50vw', marginRight: '50vw' }}
        >
          <div className="max-w-xl mx-auto  lg:max-w-7xl">
            <h2 className="sr-only">A better way to send money.</h2>
            <dl className="space-y-10 lg:space-y-0 lg:grid lg:grid-cols-3 lg:gap-12">
              <div>
                <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary-600 text-white">
                  <svg
                    className="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
                    />
                  </svg>
                </div>
                <div className="mt-5">
                  <dt className="text-lg leading-6 font-medium text-gray-900">
                    Hospitality-Level Support
                  </dt>
                  <dd className="mt-2 text-base text-gray-500">
                    TableTab comes with a full stack of support channels,
                    including phone, chat, and email. Support is handled
                    personally by our team.
                  </dd>
                </div>
              </div>

              <div>
                <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary-600 text-white">
                  <svg
                    className="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                </div>
                <div className="mt-5">
                  <dt className="text-lg leading-6 font-medium text-gray-900">
                    48-Hour Rolling Payouts
                  </dt>
                  <dd className="mt-2 text-base text-gray-500">
                    All payments processed through TableTab are immediately sent
                    to you via direct deposit and received by your bank within
                    48 hours.
                  </dd>
                </div>
              </div>

              <div>
                <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary-600 text-white">
                  <svg
                    className="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                    />
                  </svg>
                </div>
                <div className="mt-5">
                  <dt className="text-lg leading-6 font-medium text-gray-900">
                    Industry-Best Security Compliance
                  </dt>
                  <dd className="mt-2 text-base text-gray-500">
                    We securely store all data and use Stripe for payment
                    processing (PCI-certified). We do not sell any information
                    nor allow third-party ads.
                  </dd>
                </div>
              </div>
            </dl>
          </div>
          <div className="lg:w-1/6 w-full mt-10 ">
            <span
              className="flex items-center justify-center px-3 py-2 text-sm font-medium rounded-full shadow-sm text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
              onClick={() => {
                window.location.href =
                  '/use-cases/fsr?ref=use_cases_pBPO2t_button#capabilities';
              }}
            >
              See all features <span aria-hidden="true"> &rarr; </span>
            </span>
          </div>
        </div>
      </FullBackground>
    </>
  );
};

export default ProductFeatures;
